<script lang="ts">
  import type { UspModelProps } from '$lib/types/contentTypes';
  import Icon from '../control/Icon.svelte';

  export let icon: string;
  export let heading: string;
  export let description: string;
</script>

<div
  class="flex flex-col justify-top items-center gap-2 pt-10 sm:pt-16 max-w-44 min-w-[16rem] flex-grow basis-1/5"
>
  <Icon {icon} width={40} height={40} />
  <h3 class="font-semibold text-gray-900 text-xl mt-2">{heading}</h3>
  <p class="font-medium text-gray-500 text-md">{description}</p>
</div>
